<template>
	<div id="clubClass_center">
		<div class="ac-header">
			<dv-decoration-3 :color="['#151f5e', '#0cffff']" style="width:300px;height:30px;" />
			<dv-decoration-7 style="width:150px;height:30px;" :color="['#151f5e', '#0cffff']">课程相册</dv-decoration-7>
			<dv-decoration-3 style="width:300px;height:30px;" :color="['#151f5e', '#0cffff']" />
		</div>
		<!-- 课程相册 -->
		<div class="photo_bg">
			<div class="d-flex jc-center">
				<Swiper class="swiper" :options="swiperOption" ref="chartSwiper" v-if="photoNum > 0">
					<Swiper-slide class="slide" v-for="(photo, index) in photoList" :key="index">
						<img :src="cosPath + photo.photoPath" :dataInfo="photo.courseName" @click="sFlag && showBigNew()">
						<p class="img-text"> {{ photo.courseName }} </p>
					</Swiper-slide>
				</Swiper>
				<!-- 下一页 -->
				<div v-if="sFlag" class="swiper-button-next"></div>
				<!-- 上一页 -->
				<div v-if="sFlag" class="swiper-button-prev"></div>
				<!--以下看需要添加-->
				<div class="swiper-pagination"></div>
			</div>
			<Swiper class="swiper" ref="chartSwiper" v-if="photoNum == 0" style="padding-top: 0px;padding-bottom: 0.5rem;">
				<Swiper-slide class="slide">
					<img :src="require(`../../assets/img/photo_default.jpg`)">
				</Swiper-slide>
			</Swiper>
		</div>
		<dialog-swiper v-if="Visible" ref="dialog" @closeImg="closeImg"></dialog-swiper>
		<!-- 课程相册结束 -->
		<div class="class_photo"><img src="../../assets/img/photo_bg.png"></div>
	</div>
</template>
<script>
var storage = window.localStorage;
var orgId = storage.getItem("orgId");
var source = storage.getItem("source");
var sFlag = (source == 'window') ? false : true;
import { Swiper, SwiperSlide } from 'vue-awesome-swiper' // 导入组件
import "swiper/css/swiper.css"; // 导入样式
import dialogSwiper from "./dialogSwiper";
export default {
	components: {
		Swiper,
		SwiperSlide,
		dialogSwiper
	},
	data() {
		return {
			swiperOption: {},
			photoNum: 0,
			sFlag: sFlag,
			photoList: [],
			cosPath: '',
			realIndex: 0,
			Visible: false
		}
	},
	mounted() {
		this.initData();
		// 定时器刷新，10分钟
		let _this = this;
		this.interval = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 10);
	},
	methods: {
		closeImg() {
			this.Visible = false;
		},
		showBigNew() {
			console.log("showBigNew进入打开弹框函数");
			this.Visible = true;
			this.$nextTick(() => {
				//init调用的是dialog-component组件里面的init方法
				this.$refs.dialog.init(this.cosPath, '123', JSON.stringify(this.photoList), this.realIndex);
			})
		},
		showBig(cosPath, currentUrl, photoList, index) {
			console.log("进入打开弹框函数");
			this.Visible = true;
			this.$nextTick(() => {
				//init调用的是dialog-component组件里面的init方法
				this.$refs.dialog.init(cosPath, currentUrl, photoList, index);
			})
		},
		initData() {
			let _this = this;
			this.$http.get("/dataView/clubClass/getCoursePhotoInfo?orgId=" + orgId).then(res => {
				var result = res.data.result;
				_this.cosPath = result.cosPath;
				_this.photoNum = result.photoList.length;
				_this.photoList = result.photoList;
				if (result.photoList.length > 0) {
					//初始化轮播组件
					_this.swiperOption = {
						effect: "coverflow",
						coverflowEffect: {
							rotate: 70,
							stretch: 40,
							depth: 250,
							modifier: 2,
							slideShadows: true
						},
						autoplay: {
							delay: 3000,
							disableOnInteraction: false
						},
						loop: true, // 无限循环
						observer: false, //修改swiper自己或子元素时，自动初始化swiper
						observeParents: false, //修改swiper的父元素时，自动初始化swiper
						slidesPerView: "auto", // 设置可视区一共显示几张图片,设置auto,设置auto为自适应;
						centeredSlides: true, // 设置为true时,带有active-slide类名的图片会居中
						loopAdditionalSlides: 0, //loop模式下会在slides前后复制若干个slide,，前后复制的个数不会大于原总个数。默认为0，前后各复制1个。0,1,2 --> 2,0,1,2,0
						preventClicks: false,
						//  页码
						pagination: {
							el: '.swiper-pagination',
							type: 'fraction',
							dynamicBullets: true, //动态分页器的主指示点的数ss量
							clickable: true, //此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
						},
						//  点击上一页 下一页
						navigation: {
							nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
							prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
							hideOnClick: true, //点击slide时显示/隐藏按钮
							disabledClass: 'my-button-disabled', //前进后退按钮不可用时的类名。
							hiddenClass: 'my-button-hidden', //按钮隐藏时的Class
						},
						on: {
							slideChangeTransitionEnd: function () {
								console.log("slide切换");
								_this.realIndex = this.realIndex
							},
							click: function (e) {
								console.log("点击放大");
								_this.realIndex = this.realIndex
								_this.showBig(result.cosPath, e.target.currentSrc, JSON.stringify(result.photoList), this.realIndex)
							}
						},
					}
				}
			}).catch((error) => {
				console.log(error);
			})
		},
		beforeDestroy() {
			clearInterval(this.interval);
		}
	},
};
</script>
<!-- 首页切换 -->
<style lang="scss">
#clubClass_center {
	.photo_bg {
		width: 10rem;
		margin: 0 auto;
		margin-top: -0.2rem;
	}

	.ac-header {
		width: 100%;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #34deff;
		font-size: 0.22rem;
		font-weight: bold;
	}

	.jc-center {
		position: relative;
		padding-bottom: 0.5rem;
	}

	.swiper {
		height: 100%;
		width: 100%;
		padding-top: 50px;
	}

	.swiper .slide {
		width: 6rem;
		height: 4rem;

	}

	.swiper .slide img {
		display: block;
		width: 100%;
		height: 100%;
		border-radius: 0.15rem !important;
		border: 1px solid #029aff;
		box-shadow: 0 0 0.3rem #029aff;
		object-fit: cover
	}

	.swiper .slide .text {
		max-width: 5rem;
		line-height: 1.32;
	}

	.img-text {
		color: #fff;
		padding: 8px 12px;
		font-size: 0.2rem;
		background: rgba(0, 0, 0, .4);
		border-bottom: 1px solid #029aff;
		border-bottom-left-radius: 0.15rem !important;
		border-bottom-right-radius: 0.15rem !important;
		position: absolute;
		bottom: 0px;
		left: 0;
		right: 0;
	}

	.swiper-pagination {
		bottom: 0;
	}

	.swiper-pagination-bullet {
		width: 0.3rem;
		height: 0.05rem;
		border-radius: 0.1rem;
		background: #029aff;
		margin: 0 0.05rem;
	}

	.class_photo {
		width: 100%;
		margin: 0 auto;
		text-align: center;
		margin-top: -0.8rem;
	}
}
</style>